import { PROGRAMA_ID } from "../config";

export const isProgramaInovacao = (programa) =>
  programa?.nome
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .includes("INOVACAO");

export const isProgramaProcel = (programa) => programa?.id === PROGRAMA_ID.PROCEL;

/** Usuário vinculado ao programa em programa_user (user.programas vem do /auth/user). */
export const userTemPrograma = (user, programaId) =>
  !!user?.programas?.some((p) => p.id === programaId);

/** Antigo role interlocutorMercado: consultorMercado vinculado ao programa PROCEL. */
export const isInterlocutorProcel = (user) =>
  user?.roleId === "consultorMercado" && userTemPrograma(user, PROGRAMA_ID.PROCEL);

export const getDocumentoAberturaLabel = (programa) =>
  isProgramaProcel(programa)
    ? "Relatório de Pré-diagnóstico"
    : isProgramaInovacao(programa)
      ? "Ficha de abertura"
      : "Declaração";
